import { render, staticRenderFns } from "./Nps.vue?vue&type=template&id=04e78481&scoped=true"
import script from "./Nps.vue?vue&type=script&lang=js"
export * from "./Nps.vue?vue&type=script&lang=js"
import style0 from "./Nps.vue?vue&type=style&index=0&id=04e78481&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e78481",
  null
  
)

export default component.exports